import React, { useEffect, useState } from "react";
import NavBar from "../component/NavBar";
import Footer from "../component/Footer";
import img1 from "../assets/img/favicon.png";
import "../assets/css/video-js.css";
import ReactPlayer from "react-player";
import UrlParamChecker from "../component/UrlChecker";

const Tour = (props) => {

  const [link, setLink] = useState('https://rbiretaildirect.org.in/common/videos/Introduction.mp4');
  let data = [
    {
      // url: "https://pmindiawebcast.nic.in/player/vod/pmevents/media/pm12nov21.mp4",
      thumbnail: { img1 },
      isLive: false,
      header: "RBI Retail Direct",
      title: "Inauguration by Hon'ble PM of India",
      length: "",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/Introduction.mp4',
      thumbnail: { img1 },
      isLive: false,
      header: "",
      title: "Introduction",
      length: "",
      playing: true,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/Bond Basics.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "Bond Basics",
      title: "Bond Basics",
      length: "0:15",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/Types of G-Secs.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "Types of G-Secs",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/Factors Affecting G-Sec Prices.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "Factors Affecting G-Sec Prices",
      length: "0:15",
      playing: false,
    },
    // {
    //   url: 'https://rbiretaildirect.org.in/common/videos/G-Sec Returns.mp4',
    //   thumbnail: { img1 },
    //   isLive: false,
    //   linkedProducts: [],
    //   header: "",
    //   title: "G-Sec Returns",
    //   length: "10:53",
    //   playing: false,
    // },
    // {
    //   url: 'https://rbiretaildirect.org.in/common/videos/Price Yield Relationship.mp4',
    //   thumbnail: { img1 },
    //   isLive: false,
    //   linkedProducts: [],
    //   header: "",
    //   title: "Price Yield Relationship",
    //   length: "10:53",
    //   playing: false,
    // },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/Pricing of G-Secs.mp4',
      thumbnail: { img1 },
      isLive: false,
      header: "",
      linkedProducts: [],
      title: "Pricing of G-Secs - Part 1",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/Pricing of G-Secs-2.mp4',
      thumbnail: { img1 },
      isLive: false,
      header: "",
      linkedProducts: [],
      title: "Pricing of G-Secs - Part 2",
      length: "10:53",
      playing: false,
    },
    // {
    //   url: 'https://rbiretaildirect.org.in/common/videos/Risks on G-Secs.mp4',
    //   thumbnail: { img1 },
    //   isLive: false,
    //   linkedProducts: [],
    //   header: "",
    //   title: "Risks on G-Secs",
    //   length: "10:53",
    //   playing: false,
    // },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/Concept of interest rates.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "Concept of Interest Rates",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/Yield Curves.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "Yield Curves",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to do KYC.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "Primary Market",
      title: "How to KYC",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to login to account.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to Login",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to bid.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to Bid",
      length: "0:15",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to fund a bid.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to fund a Bid",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to amend a bid.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to amend a Bid",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to withdraw a bid.mp4',
      thumbnail: { img1 },
      isLive: false,
      header: "",
      linkedProducts: [],
      title: "How to withdraw a Bid",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to view allotment.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to view Allotment",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to view holdings.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to view Holdings",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to view recent auctions.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to view Recent Auctions",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to check coupon data.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to view Coupon Data",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to view redemptions.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to view Redemptions",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to view transaction history.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to view Transaction History",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/How to check fund activity log.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to view Funds Activity Log",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/sec-nds-om-access-request.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "Secondary Market",
      title: "How to register for NDS OM",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/sec-add-mw.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to set your Market Watch",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/sec-order.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to place an Order",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/sec-rfq.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to place a RFQ Quote",
      length: "10:53",
      playing: false,
    },
    {
      url: 'https://rbiretaildirect.org.in/common/videos/sec-ytm.mp4',
      thumbnail: { img1 },
      isLive: false,
      linkedProducts: [],
      header: "",
      title: "How to use the YTM Calculator ",
      length: "10:53",
      playing: false,
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  let last_video_index = 0;

  const changeVideo = (s) => {
    if (s.url) {
      data[last_video_index].playing = false;
      last_video_index = data.indexOf(s);
      data[last_video_index].playing = true;
      setLink(s.url);
    } else {
      window.open("https://pmindiawebcast.nic.in/2021/12nov21.html", "_blank");
    }
  };

  return (
    <div>
      <NavBar />
      <main id="main">
        <section id="tour" className="innerPage" style={UrlParamChecker() ? { marginTop: "16px", paddingTop: "0" } : {}}>
          <div className="container">
            <div className="section-title">
              <h2>Guided Tours</h2>
            </div>

            <div className="row page-wrapper">
              <div className="col-lg-8">
                <div className="playlist-wrapper">
                  <div className="playlist-mother-video">
                    <ReactPlayer
                      url={link}
                      muted={false}
                      playing={true}
                      controls={true}
                      config={{ file: { attributes: { controlsList: 'nodownload' } } }}
                      style={{ maxWidth: '100%' }}
                    />
                  </div>
                  <div className="playlist-products"></div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="playlist-child-videos" id="plylst_upcming">
                  {data && data.map((data, index) => (
                    <div
                      className="playlist-item-wrapper"
                      data-playing={data.playing.toString()}
                      data-live={data.isLive.toString()}
                      onClick={() => changeVideo(data)}
                    >
                      <div
                        className="playlist-thumb"
                        style={{ display: "none" }}
                      >
                        <img src={data.thumbnail} />
                        <div className="playlist-meta-length">
                          <span>{data.isLive ? "Live" : data.length}</span>
                        </div>
                      </div>
                      <div className="playlist-meta">
                        <h5 className="playlist-meta-header">{data.header}</h5>
                        <a className="playlist-meta-title">
                          <i className="ri-video-line"></i>
                          {data.title}
                        </a>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer footerClass="footerFixed" />
    </div>
  );
};

export default Tour;
